function loadModalSlider() {
  const images = document.querySelectorAll(
    "#desktop-slider img, #mobile-slider img"
  );

  images.forEach((img) => {
    img.addEventListener("click", (e) => {
      if (document.getElementById("desktop-slider") !== null) {
        if (
          !document
            .querySelector("#desktop-slider")
            .parentElement.classList.contains("zoom-fullscreen")
        ) {
          document.querySelector("#desktop-slider").classList.remove("active");
          document
            .querySelector("#desktop-slider-thumb")
            .classList.remove("active");
          imgModal();
        }
      } else {
        if (
          !document
            .querySelector("#mobile-slider")
            .parentElement.classList.contains("zoom-fullscreen")
        ) {
          document.querySelector("#mobile-slider").classList.remove("active");
          document
            .querySelector("#mobile-slider-thumb")
            .classList.remove("active");
          imgModal();
        }
      }
    });
  });

  const imgModal = () => {
    swiper.destroy();
    swiperThumb.destroy();
    document.querySelector("body").classList.add("menu-open");
    document.querySelector("#customHeader").classList.add("poupOpen");

    if (document.getElementById("desktop-slider") !== null) {
      document
        .querySelector("#desktop-slider")
        .parentElement.classList.add("zoom-fullscreen");

      const swiperThumbZoom = new Swiper("#desktop-slider-thumb", {
        slidesPerView: 5,
        freeMode: true,
        direction: "vertical",
        // height: window.innerHeight / 1.25,
        width: window.innerWidth * 0.1,
        setWrapperSize: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        speed: 300,
        cardsEffect: {
          rotate: false,
          slideShadows: false,
        },
        allowTouchMove: false,
        spaceBetween: 20,
        rewind: false,
        loop: false,
        on: {
          click: () => {
            swiperZoom.slideTo(swiperThumbZoom.clickedIndex);
          },
        },
      });

      let currentMaxRatio = 1;
      const swiperZoom = new Swiper("#desktop-slider", {
        slidesPerView: 1,
        slideToClickedSlide: false,
        height: window.innerHeight,
        speed: 300,
        cardsEffect: {
          rotate: false,
          slideShadows: false,
        },
        allowTouchMove: false,
        spaceBetween: 300,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        thumbs: {
          swiper: swiperThumbZoom,
          autoScrollOffset: 1,
        },
        zoom: {
          containerClass: "swiper-zoom-container",
          maxRatio: currentMaxRatio,
          minRatio: 1,
          toggle: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        rewind: false,
        loop: false,
        on: {
          init: () => {
            setTimeout(() => {
              const activeSlideIndex = swiperZoom.activeIndex;
              swiperThumbZoom.slideTo(activeSlideIndex + 1);
            }, 500);
          },
          slideChange: () => {
            const activeSlideIndex = swiperZoom.activeIndex;
            swiperThumbZoom.slideTo(activeSlideIndex + 1);
            currentMaxRatio = 1;
          },
          click: () => {
            swiperZoom.zoom.toggle();
          },
        },
      });

      const closeBtn = document.createElement("i");
      closeBtn.setAttribute("class", "closeBtn");
      closeBtn.onclick = () => {
        closeBtn.remove();
        resetBtn.remove();
        plusBtn.remove();
        minusBtn.remove();
        // swiperZoom.destroy();
        // swiperThumbZoom.destroy();

        document
          .querySelector("#desktop-slider")
          .parentElement.classList.remove("zoom-fullscreen");

        document.querySelector("#customHeader").classList.remove("poupOpen");
        window.location.reload();
        document.querySelector("body").classList.remove("menu-open");
      };

      const plusBtn = document.createElement("i");
      plusBtn.setAttribute("class", "plusBtn");
      plusBtn.onclick = () => {
        if (currentMaxRatio <= 3) {
          console.log(`maxRatio in: ${currentMaxRatio}`);
          currentMaxRatio += 1;
          swiperZoom.params.zoom.maxRatio = currentMaxRatio;
          swiperZoom.zoom.in();
          console.log(`maxRatio out: ${currentMaxRatio}`);

        }
        console.log(`maxRatio: ${currentMaxRatio}`);
      };

      const minusBtn = document.createElement("i");
      minusBtn.setAttribute("class", "minusBtn");
      minusBtn.onclick = () => {
        if (currentMaxRatio > 1) {
          currentMaxRatio -= 1;
          swiperZoom.params.zoom.maxRatio = currentMaxRatio;
          swiperZoom.zoom.in();
        }
        console.log(`maxRatio: ${currentMaxRatio}`);
      };

      const resetBtn = document.createElement("i");
      resetBtn.textContent = "reset";
      resetBtn.setAttribute("class", "resetBtn");
      resetBtn.onclick = () => {
        if (currentMaxRatio != 1) {
          swiperZoom.zoom.toggle();
          currentMaxRatio = 1;
          swiperZoom.params.zoom.maxRatio = currentMaxRatio;
        }
      };

      document
        .querySelector("#desktop-slider")
        .parentElement.append(closeBtn, plusBtn, minusBtn, resetBtn);

      // update the margin-left of the slider
      function updateSliderMargin() {
        const slider = document.getElementById("desktop-slider");
        const sliderThumb = document.getElementById("desktop-slider-thumb");
        const thumbWidth = sliderThumb.offsetWidth;
        slider.style.marginLeft = `${thumbWidth}px`;
      }
      setTimeout(() => {
        updateSliderMargin();
      }, 500);
      window.addEventListener("resize", updateSliderMargin);
    } else {
      document
        .querySelector("#mobile-slider")
        .parentElement.classList.add("zoom-fullscreen");

      const swiperThumbMobileZoom = new Swiper("#mobile-slider-thumb", {
        slidesPerView: 3,
        freeMode: true,
        // height: window.innerHeight / 1.25,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        speed: 300,
        cardsEffect: {
          rotate: false,
          slideShadows: false,
        },
        allowTouchMove: true,
        spaceBetween: 20,
        rewind: false,
        loop: false,
        on: {
          click: () => {
            swiperZoomMobile.slideTo(swiperThumbMobileZoom.clickedIndex);
          },
        },
      });

      const swiperZoomMobile = new Swiper("#mobile-slider", {
        slidesPerView: 1,
        slideToClickedSlide: false,
        speed: 300,
        cardsEffect: {
          rotate: false,
          slideShadows: false,
        },
        allowTouchMove: true,
        spaceBetween: 300,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        thumbs: {
          swiper: swiperThumbMobileZoom,
          autoScrollOffset: 1,
        },
        zoom: {
          containerClass: "swiper-zoom-container",
          maxRatio: 4,
          minRatio: 1,
          toggle: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        rewind: false,
        loop: false,
        on: {
          init: () => {
            setTimeout(() => {
              const activeSlideIndex = swiperZoomMobile.activeIndex;
              swiperThumbMobileZoom.slideTo(activeSlideIndex + 1);
            }, 500);
          },
          slideChange: () => {
            const activeSlideIndex = swiperZoomMobile.activeIndex;
            swiperThumbMobileZoom.slideTo(activeSlideIndex + 1);
          },
          click: () => {
            swiperZoomMobile.zoom.toggle();
          },
        },
      });

      const closeBtnMobile = document.createElement("i");
      closeBtnMobile.setAttribute("class", "closeBtn");
      closeBtnMobile.onclick = () => {
        closeBtnMobile.remove();
        resetBtnMobile.remove();
        // swiperZoom.destroy();
        // swiperThumbZoom.destroy();

        document
          .querySelector("#mobile-slider")
          .parentElement.classList.remove("zoom-fullscreen");

        document.querySelector("#customHeader").classList.remove("poupOpen");
        window.location.reload();
        document.querySelector("body").classList.remove("menu-open");
      };

      const resetBtnMobile = document.createElement("i");
      resetBtnMobile.textContent = "reset";

      resetBtnMobile.setAttribute("class", "resetBtn");
      resetBtnMobile.onclick = () => {
        swiperZoomMobile.zoom.out();
      };

      document
        .querySelector("#mobile-slider")
        .parentElement.append(closeBtnMobile, resetBtnMobile);
    }

    setTimeout(() => {
      document.querySelector(".zoom-fullscreen").classList.add("active");
    }, 1000);
  };
}

const mobileSwiperOptions = {
  // zoom: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  // followFinger: false,
  // slidesPerView: 1,
  // slideToClickedSlide: false,
  speed: 300,
  // allowTouchMove: true,
  spaceBetween: 100,
  // allowSlideNext: true,
  // allowSlidePrev: true,
  zoom: {
    containerClass: "swiper-zoom-container",
    maxRatio: 3,
    minRatio: 1,
    toggle: true,
  },
  // watchOverflow: true,
  // breakpoints: {
  //   767: {
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //   },
  // },
  // rewind: false,
  // loop: false,
  on: {
    click: () => {
      // this.zoom.toggle();
      // loadZoom();
    },
  },
};

const swiperThumb = new Swiper("#desktop-slider-thumb", {
  slidesPerView: 2,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  speed: 300,
  cardsEffect: {
    rotate: false,
    slideShadows: false,
  },
  allowTouchMove: false,
  spaceBetween: 50,
  rewind: false,
  loop: false,
  on: {
    click: () => {
      swiper.slideTo(swiperThumb.clickedIndex);
    },
  },
});

const swiperOptions = {
  slidesPerView: 1,
  slideToClickedSlide: false,
  speed: 300,
  cardsEffect: {
    rotate: false,
    slideShadows: false,
  },
  allowTouchMove: false,
  spaceBetween: 300,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  thumbs: {
    swiper: swiperThumb,
    autoScrollOffset: 1,
  },
  zoom: {
    containerClass: "swiper-zoom-container",
    maxRatio: 3,
    minRatio: 1,
    toggle: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  rewind: false,
  loop: false,
  on: {
    init: () => {
      setTimeout(() => {
        const activeSlideIndex = swiper.activeIndex;
        swiperThumb.slideTo(activeSlideIndex + 1);
      }, 500);
    },
    slideChange: () => {
      const activeSlideIndex = swiper.activeIndex;
      swiperThumb.slideTo(activeSlideIndex + 1);
    },
    // click: () => {
    //   // this.zoom.toggle();
    //   loadZoom();
    // },
  },
};

let swiper = null;
// let swiperThumb = null;

const desktopSlider = document.getElementById("desktop-slider");
const desktopSliderThumb = document.getElementById("desktop-slider-thumb");
const mobileSlider = document.getElementById("mobile-slider");
const breakpointSm = window.matchMedia("(max-width: 1024px)");
const breakpoint = window.matchMedia("(min-width:1025px)");

if (desktopSlider !== null || mobileSlider !== null) {
  if (breakpointSm.matches === true) {
    // if small breakpoint, show mobileSlider if exists, otherwise show desktopSlider

    const isMobileSliderEmpty =
      mobileSlider === null ||
      mobileSlider.querySelector(".swiper-wrapper").innerHTML === "";

    if (isMobileSliderEmpty) {
      if (mobileSlider !== null) {
        mobileSlider.remove();
      }
      // desktopSliderThumb.style.display = "block";
      desktopSlider.style.display = "block";
      // swiperThumb = new Swiper("#desktop-slider-thumb", swiperThumbOptions);
      swiper = new Swiper("#desktop-slider", swiperOptions);
    } else {
      if (desktopSlider !== null) {
        // desktopSliderThumb.remove();
        desktopSlider.remove();
      }
      swiper = new Swiper("#mobile-slider", mobileSwiperOptions);
    }

    setTimeout(() => {
      document.querySelector("#mobile-slider").classList.add("active");
    }, 500);
    loadModalSlider();
  } else if (breakpoint.matches === true) {
    if (mobileSlider !== null) {
      mobileSlider.remove();
    }
    // swiperThumb = new Swiper("#desktop-slider-thumb", swiperThumbOptions);
    swiper = new Swiper("#desktop-slider", swiperOptions);

    loadModalSlider();
    setTimeout(() => {
      document.querySelector("#desktop-slider").classList.add("active");
      document.querySelector("#desktop-slider-thumb").classList.add("active");
    }, 1000);
  }
}

// function loadZoom() {
//   const body = document.querySelector("body");
//   const isZoomed = body.classList.contains("zoomed");

//   if (!isZoomed) {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//     body.classList.add("zoomed");
//     var closeBtn = document.createElement("i");
//     closeBtn.className = "closeBtn";
//     closeBtn.onclick = () => {
//       swiper.zoom.toggle();
//       body.classList.remove("zoomed");
//       var closeBtns = document.querySelectorAll("i.closeBtn");
//       closeBtns.forEach((btn) => {
//         btn.remove();
//       });
//     };
//     document.querySelector(".pdp-slider").append(closeBtn);
//   }

//   swiper.zoom.toggle();
// }
